import dayjs from "./dayjs";

export const getPatientAge = (value: Date | string): number => {
  // Date objects come from yup's date transform; strings are MM/DD/YYYY from the API
  const dob = value instanceof Date ? dayjs(value) : dayjs(value, "MM/DD/YYYY");

  return dayjs().diff(dob, "year", true);
};
